import FaxManagmentRouting from './FaxManagement.routing';

export default FaxManagmentRouting;
